import React from 'react';

import { Card } from '@copilot/ui';
import Icon from '../common/Icon';

// Reuses the exact .stat-card/.stat-card-icon/.stat-card-value/
// .stat-card-label classes DashboardPage.jsx already established
// (styles/layout.css) - same shell, just parameterized so six admin
// cards don't repeat the same markup.
function AdminStatCard({ title, value, icon, description, loading = false }) {
  return (
    <Card interactive className="stat-card">
      <div className="stat-card-icon">
        <Icon name={icon} />
      </div>
      <div>
        <div className="stat-card-value">
          {loading ? <span className="stat-card-skeleton" /> : value}
        </div>
        <div className="stat-card-label">{title}</div>
        {!loading && description && (
          <div className="stat-card-description">{description}</div>
        )}
      </div>
    </Card>
  );
}

export default AdminStatCard;
